const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-white">
      <div className="container mx-auto px-6 py-16 max-w-[1140px]">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* About Raissy Group */}
          <div>
            <h3 className="text-base font-bold text-white mb-6">About Raissy Group</h3>
            <ul className="space-y-3">
              <li>
                <a href="/overview" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Overview
                </a>
              </li>
              <li>
                <a href="/innovation" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Innovation
                </a>
              </li>
              <li>
                <a href="/awards-recognition" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Awards & Recognition
                </a>
              </li>
              <li>
                <a href="/annual-review" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Annual Review
                </a>
              </li>
              <li>
                <a href="/leadership" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Board of Directors
                </a>
              </li>
              <li>
                <a href="/leadership/chairman" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Chairman Emeritus
                </a>
              </li>
              <li>
                <a href="/corporate-policies" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Corporate Policies
                </a>
              </li>
            </ul>
          </div>

          {/* Businesses */}
          <div>
            <h3 className="text-base font-bold text-white mb-6">Businesses</h3>
            <ul className="space-y-3">
              <li>
                <a href="/businesses#construction" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Construction
                </a>
              </li>
              <li>
                <a href="/businesses#energy" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Energy
                </a>
              </li>
              <li>
                <a href="/businesses#manufacturing" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Manufacturing
                </a>
              </li>
              <li>
                <a href="/businesses#services" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Services
                </a>
              </li>
              <li>
                <a href="/businesses#alliedbusinesses" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Allied Businesses
                </a>
              </li>
            </ul>
          </div>

          {/* Careers */}
          <div>
            <h3 className="text-base font-bold text-white mb-6">Careers</h3>
            <ul className="space-y-3">
              <li>
                <a href="/careers" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Overview
                </a>
              </li>
              <li>
                <a href="/careers/campus-engage" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Campus Engage
                </a>
              </li>
              <li>
                <a href="/careers/learning-development" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Learning & Development
                </a>
              </li>
              <li>
                <a href="/careers/diversity-equity-inclusion" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Diversity, Equity & Inclusion
                </a>
              </li>
              <li>
                <a href="/careers/renew" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Renew
                </a>
              </li>
              <li>
                <a href="/careers/recruitment-caution" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Recruitment Caution
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h3 className="text-base font-bold text-white mb-6">Contact Us</h3>
            <div className="text-sm text-white/80 leading-relaxed space-y-3">
              <p>
                <a href="/contact" className="font-bold text-white hover:underline cursor-pointer">
                  View all Contacts
                </a>
              </p>
              <p>
                Raissy Limited<br />
                CIN – L99999MH1946PLC004768<br />
                Raissy House, N.M. Marg, Ballard Estate, Mumbai, Maharashtra - 400 001
              </p>
              <p>
                Tel: <a href="tel:+912267525656" className="hover:text-white cursor-pointer">+91 22 67525656</a><br />
                Fax: +91 22 67525858<br />
                Send us a mail: <a href="mailto:infodesk@raissy.com" className="hover:text-white cursor-pointer">infodesk@raissy.com</a>
              </p>
            </div>
          </div>

          {/* Sustainability */}
          <div>
            <h3 className="text-base font-bold text-white mb-6">Sustainability</h3>
            <ul className="space-y-3">
              <li>
                <a href="/sustainability" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Overview
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-6 py-6 max-w-[1140px]">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            {/* Social Media */}
            <div className="flex items-center space-x-4">
              <p className="text-sm text-white/80">Follow Us</p>
              <div className="flex items-center space-x-3">
                <a
                  href="https://www.linkedin.com/company/raissy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
                  aria-label="LinkedIn"
                >
                  <i className="ri-linkedin-fill text-base"></i>
                </a>
                <a
                  href="https://www.youtube.com/raissy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
                  aria-label="YouTube"
                >
                  <i className="ri-youtube-fill text-base"></i>
                </a>
                <a
                  href="https://twitter.com/raissy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-fill text-base"></i>
                </a>
              </div>
            </div>

            {/* Links & Copyright */}
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
              <div className="flex items-center space-x-6">
                <a href="/copyright-terms" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Copyright & Terms
                </a>
                <a href="/privacy-policy" className="text-sm text-white/80 hover:text-white transition-colors cursor-pointer">
                  Privacy Policy
                </a>
              </div>
              <p className="text-sm text-white/80">
                © 2026 RAISSY LIMITED. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
